/** @format */

import React, { useEffect } from "react"; // Import useEffect
import { Link } from "react-scroll";
import ScrollReveal from "scrollreveal"; // Import ScrollReveal
import Title from "./mini-components/Title";

export default function PresentationSection() {
  useEffect(() => {
    // Initialize ScrollReveal
    const sr = ScrollReveal({
      origin: "bottom", // Change this based on your preferred direction
      distance: "30px",
      duration: 500,
      delay: 100,
      easing: "ease-in-out",
    });

    // Reveal elements
    sr.reveal(".reveal", { interval: 100 }); // Applies reveal to all elements with class 'reveal'
  }, []);

  return (
    <div className="relative">
      <section id="presentation" className="w-11/12 mx-auto pt-4">
        {/* Titre de la section */}
        <Title title="Présentation" textplacement="left" />

        {/* Paragraphe de description */}
        <p className="text-lg sm:text-xl lg:text-2xl text-justify max-w-3xl mx-auto mt-6 sm:mt-8 leading-relaxed text-gray-700 reveal">
          <b>Plan&Drive</b> est une solution spécialement conçue pour les
          petites entreprises spécialisées dans le <b>transport</b>. Cette
          application optimise les plannings de livraison et maximise l'
          <b>efficacité</b> de votre flotte. Grâce à l'intégration avec
          Telegram, vos chauffeurs reçoivent leurs rendez-vous et plannings en
          <b> temps réel</b>, directement sur leur mobile.
        </p>

        {/* Conteneur des fonctionnalités et avantages */}
        <div className="flex flex-col md:flex-row justify-between items-stretch mt-12 sm:mt-16 border-t-2 border-b-2 border-green-800 py-8 sm:py-12 reveal">
          {/* Colonne gauche : Fonctionnalités */}
          <div className="flex-1 md:border-r-2 border-green-800 p-6 sm:p-8">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl text-green-800 mb-4 sm:mb-6 reveal">
              Fonctionnalités clés
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-base sm:text-lg lg:text-xl text-gray-800">
              <li className="reveal">
                Planification des tournées
                <p className="text-gray-500 text-sm sm:text-base">
                  Créez des plannings optimisés en tenant compte des contraintes
                  de temps, de distance et de disponibilités.
                </p>
              </li>
              <li className="reveal">
                Intégration de Telegram
                <p className="text-gray-500 text-sm sm:text-base">
                  Vos chauffeurs reçoivent leurs plannings de la journée et des
                  notifications instantanées via Telegram.
                </p>
              </li>
              <li className="reveal">
                Optimisation des trajets
                <p className="text-gray-500 text-sm sm:text-base">
                  Calcul automatique des itinéraires les plus courts et les plus
                  rapides.
                </p>
              </li>
              <li className="reveal">
                Impression des plannings
                <p className="text-gray-500 text-sm sm:text-base">
                  Imprimez facilement vos plannings pour vos bureaux.
                </p>
              </li>
              <li className="reveal">
                Systèmes d'autorisation
                <p className="text-gray-500 text-sm sm:text-base">
                  Autorisez ou non vos collaborateurs à voir et/ou modifier le
                  planning en temps réel.
                </p>
              </li>
            </ul>
          </div>

          {/* Colonne droite : Avantages */}
          <div className="flex-1 p-6 sm:p-8">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl text-green-800 mb-4 sm:mb-6 reveal">
              Avantages
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-base sm:text-lg lg:text-xl text-gray-800">
              <li className="reveal">
                Gain de temps
                <p className="text-gray-500 text-sm sm:text-base">
                  Réduisez le temps passé à planifier et à gérer vos livraisons.
                </p>
              </li>
              <li className="reveal">
                Réduction des coûts
                <p className="text-gray-500 text-sm sm:text-base">
                  Optimisez vos itinéraires pour économiser du carburant et
                  réduire l'usure de vos véhicules.
                </p>
              </li>
              <li className="reveal">
                Amélioration de la satisfaction client
                <p className="text-gray-500 text-sm sm:text-base">
                  Garantissez des livraisons à temps et améliorez la
                  communication avec vos clients et vos employés.
                </p>
              </li>
              <li className="reveal">
                Simplicité d'utilisation
                <p className="text-gray-500 text-sm sm:text-base">
                  Une interface intuitive, conçue pour être utilisée sans
                  formation technique préalable.
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center items-center flex-col mt-8">
          <Link
            to="galeries"
            smooth={true}
            duration={500}
            className="cursor-pointer bg-white text-green-900 px-6 py-2 sm:px-8 sm:py-3 rounded-lg hover:bg-green-900 hover:text-white transition duration-150 ease-in-out reveal"
          >
            Voir la galerie
          </Link>
        </div>
      </section>
    </div>
  );
}
